const { default: favorites } = require("@/store/modules/landing/favorites");

module.exports = {
  landing: {
    allCourses: "Барлық үйірмелер",
    popularCourses: "Танымал курстар",
    tutoring: "Репетиторлық және жеке сабақтар",
    vacancies: "Вакансия",
    allCoursesForMobile: "Үйірмелер",
    popularCoursesForMobile: "Танымалдар",
    tutoringForMobile: "Репетитор",
    vacanciesForMobile: "Вакансия",
    main: "Бас бет",
    favorites: "Таңдаулылар",
    support: "Тех. қолдау",
    forCenters: "Орталықтар үшін",
    loginBtn: "Кіру",
    profileBtn: "Профиль",
    exitBtn: "Шығу",
    zerekTitlePart1: "Қосымша білім",
    zerekTitlePart2: "",
    mainSlideTitle:
      "Балаңыздың қосымша білім алуын бүгіннен бастап қамтамасыз етіңіз!",
    mainSlideDescription:
      "Балаңызды тегін  және ақылы қосымшалар мен үйірмелерге оқыту үшін дәл қазір өтініш тастаңыз!",
    mainSlideBtnText: "Өтініш жіберу",
    zerekInfoTitle: "Zerek EDUS",
    zerekInfoText1: "Zerek EDUS — балаңызға ең үздік және қолайлы үйірме мен секцияларды іздеп табуға арналған жобаға қош келдіңіз! Біздің жүйемізде баланың жасы мен қызығушылығына сәйкес келетін спорттық, шығармашылық және ғылыми бағыттағы қосымшалардың кең таңдауын таба аласыз.",
    zerekInfoText2: "орталықтар",
    zerekInfoText3: "үйірмелер",
    zerekInfoText4: "нарықта",
    zerekInfoTitle4: "2023 ж.",
    year: "жыл",
    zerekInfoText5:
      "Платформада сіз кез-келген жастағы баланың қызығушылығына арналған спорттық, шығармашылық және ғылыми бағыттардағы тегін және ақылы үйірмелер жиналған. Сіздің балаңыздың қабілеті мен қызығушылығын дамытудағы үздік Білім орталықтары, мұғалімдер мен жаттықтырушыларды жүйеден жиналған. Zerek EDUS: Өз балаңыз үшін хобби әлемін ашыңыз!",
    coursesTitle: "Үйірмелер",
    videoBlockTitle: "Жүйе бойынша сұрақтарыңыз болса",
    videoBlockDescription:
      "Жүйемен толықтай танысқыңыз келсе, бейнероликтегі нұсқаулықпен танысыңыз.",
    videoBlockBtn: "Бейнеролик көру",
    closeVideoModal: "Жабу",
    topOrganizationsTitle: "Үздік ұйымдар",
    topTeachersTitle: "100+ тәжірибелі мұғалімдер",
    reviewsTitle: "Ата-ана пікірлері",
    shown: "",
    from: "",
    seeAll: "Барлығын көру",
    stars: "жұлдыз",
    questionsTitle: "Жиі қойылатын",
    questionsTitleStyled: "сұрақтар",
    questionTitle1: "Неге менің балам жеке кабинетімде көрінбейді?",
    questionDescription1:
      "Балаңызды жүйеге қосу үшін өз жеке кабинетіңізде, “Балалар” бөлімінде “Баланы қосу” батырмасын басыңыз. Батырманы басқаннан кейін сіздің Мобильді азаматтар базасында (МАБ) тіркелген телефон нөміріңізге СМС хат барады, сол нөмірге жауап ретінде СМС-те көрсетілген “Иә” сөзіне сәйкес келетін код цифраны жауап ретінде қайтарыңыз. Кодты жібергеннен кейін ашылған мәзірде “Жаңарту” батырмасын басыңыз. Егер балаңыз қосылмаған жағдайда техникалық қолдау қызметіне жазыңыз.",
    questionTitle2:
      "Жүйеге қалай тіркелемін? Неге жеке кабинетке кіре алмаймын?",
    questionDescription2:
      "Біздің платформада жүйеге тіркелу тұлғаның ЭЦҚ кілті арқылы жүзеге асырылады. Сондықтан жүйеге кіру үшін NCALayer бағдарламасы орнатылған ноутбук немесе дербес компьютерді қолданыңыз. NCALayer бағдарламасын ҚР Ұлттық куәландырушы орталығының жеке сайтынан басып ала аласыз.",
    questionTitle3: "Неге тіркелу кезінде менің жеке ақпараттарым сұралады?",
    questionDescription3:
      "Платформада қолданушылардың жеке деректері сіздің балаларыңыз туралы мәліметтерді дұрыс енгізу, тұлғаның шынайылығын растау, жүйедегі ашықтықты қамтамасыз ету, сондай-ақ Қазақстан Республикасы Білім және ғылым министрінің 2020 жылғы 22 мамырдағы №219 бұйрығына сәйкес қосымша білім беру ұйымдарына құжаттарды дұрыс рәсімдеу мақсатында сұралады. Бұл шаралар жалған немесе адал емес өтінімдердің алдын алу және тұлға туралы ақпаратты дәл енгізу үшін қажет. Біздің жүйедегі барлық жеке деректер Қазақстан Республикасының 2013 жылғы 21 мамырдағы №94-V «Дербес деректер және оларды қорғау туралы» заңы бойынша сақталып, қорғалады.",
    questionTitle4:
      "СМС хаттама қандай мақсатта жіберіледі? Мен қандай деректерге келісім беремін?",
    questionDescription4:
      "Zerek EDUS платформасында бала туралы ақпарат ЖК МДҚ («Жеке тұлғалар» Мемлекеттік деректер қоры) жүйесінен алынады. Бұл жүйеден бала туралы деректерді енгізу тек оның ата-анасы рұқсатымен жүзеге асырылады, сол себептен сізге рұқсат алу СМС хаттамасы жіберіледі. ",
    questionTitle5: "Неге СМС хаттама менің телефон нөміріме келмейді?",
    questionDescription5:
      "Рұқсат алу СМС хаттамсы сіздің тек Мобильді азаматтар базасында (МАБ) тіркелген нөміріңіз арқылы жіберіледі, егер нөміріңізге СМС хаттама келмесе, eGov порталында өз жеке кабинетіңізге кіру арқылы дұрыс телефон нөмірі енгізілгенін тексеріңіз. Егер байланыс нөміріңіз қате көрсетілген немесе енгізілмеген болса, жаңа телефон нөмірін енгізу туралы нұсқаулықты келесі сілтеме бойынша қолданыңыз: https://egov.kz/cms/kk/articles/mobilecitizen. Егер де байланыс нөміріңіз дұрыс тіркелген, алайда СМС хаттама сонда да келмеген жағдайда біздің жүйеміздің техникалық қолдау қызметіне жазыңыз.",
    footerTitle: "Сіздер үшін - әрқашан байланыста!",
    edusSystems: "EDUS System © 2025",
    rights: "Барлық құқықтар қорғалған",
    footerAboutCompany: "Компания туралы",
    footerConsultationTitle: "Кеңес алғыңыз келе ме?",
    footerSendBtn: "Жіберу",
    footerFormLabel: "Пошта",
    useConditions: "Пайдалану шарттары",
    privacyPolicy: "Құпиялылық саясат",
    zerekTitle: "Қосымша білім",
    students: "оқушы оқып жатыр",
    "noTopOrganizations": "Үздік ұйымдар табылмады",
    "beTheFirst": "Бірінші болыңыз!",
  },

  allCourses: {
    circlesTab: "Білім беру үйірмелері",
    sportcoursesTab: "Спорт үйірмелері",
    culturecoursesTab: "Шығармашылық үйірмелері",
    centersTab: "Орталықтар",
    favoritesTab: "Таңдаулылар",
    searchLabel: "Үйірмелерді іздеу",
    backBtn: "Артқа",
    teacher: "Оқытушы",
    price: "Бағасы",
    month: "ай",
    shareCourse: "Курспен бөлісу",
    numberOfGrades: "баға саны",
    applyForCourse: "Курсқа өтініш беру",
    requirements: "Талаптар",
    whyPeople: "Неліктен адамдар",
    choose: "таңдайды?",
    studyTime: "Оқу уақыты",
    availableSeats: "Қолжетімді орын саны",
    hour_week: "сағ/апта",
    backButton: "Артқа",
    numberOfCourses: "Үйірмелер саны",
    numberOfContingents: "Контингент саны",
    directions: "Бағыттар",
    aboutSchool: "Орталық жайлы",
    courses: "үйірмелері",
    address: "Мекенжайы",
    phone_number: "Телефон нөмірі",
    language: "Оқыту тілі",
    available_count: "Қолжетімді орын саны",
    ageRange: "Жас аралығы",
    linkCopied: "Сілтеме көшірілді!",
    linkCopiedSuccess: "Курс сілтемесі сәтті көшірілді!",
    linkCopyError: "Сілтемені көшіру сәтсіз аяқталды.",
    zerekTitle: "Қосымша білім",
    is_gov: "Мемлекеттік?",
    gos_organization: "Мемлекеттік ұйым",
    private_organization: "Жеке ұйым",
    free: "Тегін",
    perMonth: "₸/ай",
    "schedule": "Сабақ кестесі",
    applicationSuccess: "Өтініш жіберілді",
    applicationError: "Қателік",
    noCourses: "Үйірмелер табылмады",
    noCenters: "Орталықтар табылмады",
    addedToFavorites: "Таңдаулыларға қосылды",
    removedFromFavorites: "Үйірме таңдаулылардан жойылды",
    age: "жас",
  },

  dataTable: {
    rowsPerPage: "Бір беттегі жазбалар саны",
    all: "Барлығы",
  },

  popularCourses: {
    title: "Деректер жоқ",
  },

  reviews: {
    noReviews: "Пікірлер әлі жоқ",
  },

  notFoundPage: {
    errorTitle: "Бет табылмады",
    errorDescription:
      "Өкінішке орай, сіз іздеген бет табылмады. Мүмкін, ол жойылған немесе сіз мекенжайды қате енгіздіңіз.",
    backLink: "Басты бетке оралу",
  },

  "days": {
    "monday": "Дүйсенбі",
    "tuesday": "Сейсенбі", 
    "wednesday": "Сәрсенбі",
    "thursday": "Бейсенбі",
    "friday": "Жұма",
    "saturday": "Сенбі",
    "sunday": "Жексенбі"
  },

  tutoring: {
    tutoringTitle1: "Балалар мен жасөспірімдерге арналған",
    tutoringTitle2: "жеке",
    tutoringTitle3: " оқыту",
    showPhoneBtn: "Телефонды көрсету",
    month: "ай",
    searchLabel: "Үйірмелерді іздеу",
    year: "Жас",
    noTutors: "Мұғалім табылмады",
    perLesson: "₸/сабақ"
  },

  vacancies: {
    vacanciesTitle: "Вакансиялар",
    replyBtn: "Телефонды көрсету",
    searchLabel: "Үйірмелерді іздеу",
    priceFrom: "Қолға",
    onHands: "бастап",
    experience: "Тәжірибе",
    schedule: "Кесте",
    year: "ж.",
    noVacancies: "Вакансиялар жоқ",
  },

  filter: {
    regionsTitle: "Облыстар",
    allRegionsTitle: "Барлық облыстар",
    priceTitle: "Бағасы",
    priceFrom: "от",
    priceTo: "до",
    directionTitle: "Бағыты",
    allDirectionsTitle: "тағы...",
    langOfInstructionsTitle: "Оқыту тілі",
    allLanguagesTitle: "Барлық тілдер",
    educationLevelTitle: "Білім дәрежесі",
    workExperienceTitle: "Жұмыс тәжірибесі",
    workScheduleTitle: "Жұмыс кестесі",
  },

  profile: {
    profileTab: "Профиль",
    childrenTab: "Балалар",
    requestsTab: "Менің өтініштерім",
    tabelsTab: "Табельдер",
    accountDetails: "Пайдаланушының деректері",
    name: "Аты-жөні",
    email: "Электронды пошта",
    workplace: "Жұмыс орны",
    phone: "Байланыс нөмірі",
    additionalPhone: "Қосымша байланыс нөмірі",
    docType: "Құжат түрі",
    docNumber: "Құжат №",
    issuedBy: "Берген орган",
    issueDate: "Берілген мерзімі",
    cancelButton: "Бас тарту",
    saveButton: "Сақтау",
    noSubjects: "Оқу пәндері жоқ",
    addChild: "Тіркеу",
    noChildren: "Балалар әлі тіркелмеген",
    noChildrenDescription: "Балаңызды қосу үшін «Тіркеу» батырмасын басыңыз және нұсқаулықты орындаңыз.",
  },

  children: {
    calendarTitle: "Күнтізбе және журнал",
    searchLabel: "Үйірмелерді іздеу",
    share: "Поделиться расписанием",
    acts: "Табельдер",
    studyTime: "Аптасына",
    class: "сынып",
    actNumber: "Табель нөмірі",
    courseName: "Үйірме атауы",
    data: "Мезгілі",
    teacher: "Оқытушы",
    status: "Мәртебесі",
    close: "Жабу",
    branch: "Орталық"
  },

  login: {
    title: "Жүйеге кіру",
    byECP: "ЭЦҚ арқылы",
    byEGOV: "eGov mobile",
    chooseCertificateBtn: "Сертификатты таңдаңыз",
    passwordLabel: "Құпия сөз",
    loginBtn: "Кіру",
    loginLogoText: "Қосымша білім",
    consentMessage: 'Ақпараттық жүйеге қол жеткізу Қазақстан Республикасының дербес деректер туралы заңнамасына сәйкес жүзеге асырылады. Деректерге рұқсатсыз қол жеткізу, көшіру және таратуға тыйым салынады.',
    consentButton: 'Келісемін'
  },

  registration: {
    step: "қадам",
    steps: {
      firstStep: "1-қадам",
      secondStep: "2-қадам",
      thirdStep: "3-қадам",
    },
    firstStep: {
      title: "Дербес деректер",
      documentTypeLabel: "Құжат типі",
      documentNumberLabel: "Құжат №",
      organ: "Берген орган",
      timeToGive: "Берілу мезгілі",
      iAgree: "Мен ",
      processingData: "жеке деректерді өңдеуге келісім беремін",
      nextBtn: "Келесіге өту",
    },
    secondStep: {
      title: "Байланыс деректері",
      numberLabel: "Телефон нөмірі",
      additionalNumberLabel: "Қосымша телефон нөмірі",
      emailLabel: "Email адрес",
      workplace: "Жұмыс орны",
      processingData: "дербес деректерді өңдеуге келісім беремін",
      saveBtn: "Сақтау",
      backBtn: "Артқа",
    },
    thirdStep: {
      title: "Балалар",
      description:
        "Сіздің Мобильдік азаматтар базасында (МАБ) тіркелген нөміріңізге, SMS (СМС) жіберілді. Балаларды қосу үшін, сол хабарламаға <strong>«Иә»</strong> деген жауапты білдіретін код түрінде SMS жауап қайтарыңыз.",
      nextBtn: "Балаларды экспорт жасау",
      skip: "Өткізіп жіберу",
      toProfileBtn: "Профильге өту",
    },
  },

  acts: {
    actsList: "Табельдер тізімі",
    showAll: "барлығын қарау",
    actNumber: "Табель нөмірі",
    actsDetail: {
      course: "Үйірме",
      date: "Мезгілі",
      file: "Файл",
      hoursElapsed: "Сабақ саны",
      reasonOfRefusal: "Себебі",
      backButton: "Артқа өту",
      cancelButton: "Бас тарту",
      acceptButton: "Қабылдау",
      teacher: "Оқытушы",
      status: "Мәртебесі",
      actWithNumber: "",
      actSigned: "нөмірлі табель сәтті қабылданды",
      actRejected: "нөмірлі табель ата-анамен бас тартылды",
    },
    confirmTitle: "Растау",
    confirmAcceptText: "Табельді қабылдауға сенімдісіз бе?",
    confirmRejectText: "Табельді кері қайтаруға сенімдісіз бе?",
    confirm: "Иә",
    cancel: "Жоқ",
    commentPlaceholder: "Түсініктеме",
    rejectCommentRequired: "Бас тарту себебін көрсетіңіз.",
    diaryDate: "Күні",
    diaryTime: "Уақыты",
    diaryStatus: "Сабақ статусы",
    diaryMark: "Баға"
  },

  tabels: {
    studying: "Қабылданған",
    expelled: "Үйірмеден шығарылған",
    unsignedTabelCount: "Қол қойылмаған табельдер",
    table: {
      center: "Орталық",
      course: "Үйірме",
      status: "Мәртебесі",
      actions: "",
    },
  },

  applications: {
    numberOfApplications: "Өтініш саны",
    lastApplication: "Соңғы өтініш",
    table: {
      center: "Орталық",
      course: "Үйірме",
      category: "Санаты",
      status: "Мәртебесі",
      date: "Берілген уақыты",
      actions: "",
    },
    applicationDetail: {
      downloadFile: "Файлды жүктеу",
      status: "Мәртебесі",
      reason: "Себебі",
      birthCertificate: "Туу туралы куәлік",
      medicalCertificate: "Медициналық анықтама",
      category: "Санаты",
      statement: "Өтініш",
      submitted: "Жіберу уақыты",
      perMonth: "₸/ай",
      toBeExpelledButton: "Оқудан шығу",
      ratings: "баға саны",
      oneLesson: "Бір сабақ",
      hours: "сағат",
      perWeek: "Аптасына",
      applicationNumber: "Өтініш нөмірі",
      downloadCertificate: "Куәлікті жүктеу",
      downloadMedicalCertificate: "Медициналық анықтаманы жүктеу",
      downloadApplication: "Өтінішті жүктеу",
      deleteApplication: "Өтінішті жою",
      withdrawApplication: "Шығу",
      toCourse: "Курсқа өту",
      deleteConfirmText: "Өтінішті жойғыңыз келетініне сенімдісіз бе?",
      withdrawConfirmText: "Сіз шынымен шығуды қалайсыз ба?",
      confirmTitle: "Растау",
      confirmDeleteText: "Сіз өтінішті жойғыңыз келетініне сенімдісіз бе?",
      confirmWithdrawText: "Сіз оқу орнынан шығуды қалайсыз ба?",
      confirm: "Иә",
      cancel: "Жоқ",
      socialCategoryDocument: "Әлеуметтік санат анықтамасы",
      downloadSocialCategoryDocument: "Әлеуметтік санат анықтамасын жүктеу",
      subGroupName: "Ішкі топ",
    },
  },

  toastText: {
    successfullySaved: "Өзгерістер сәтті сақталды!",
    errorData: "Сұранысты өңдеу кезінде қате орын алды",
    loginError: "Қате орын алды",
    ecpKey: "ЭЦҚ кілтін және паролді енгізіңіз!",
    fields: "Барлық деректерді дұрыс толтырыңыз",
    wentWrong: "Қате орын алды. Жаңадан қайталап көріңіз!",
    sendSMS: "Сіздің телефон нөміріңізге SMS жіберілді. Оған жауап беріп, түймені қайта басыңыз.",
    actSuccessSubmit: "Табельге қол қойылды",
    actReject: "Табельден бас тартылды",
    applicationDeleted: "Өтініш сәтті жойылды",
    applicationWithdrawn: "Сіз сәтті шығарылдыңыз",
    saveError: "Сақтау кезінде қателік туындады",
    formError: "Формада қате бар",
    validationError: "Енгізілген деректерді тексеріңіз",
    serverError: "Сервер қатесі, кейінірек көріңіз",
    smsNotAnswered: "SMS-ке жауап бермедіңіз",
    childAddedSuccess: "Балалар тіркелді",
    noChildrenFound: "Балалар табылмады",
    smsAnsweredNoCorrectly: "Сіз SMS-ке дұрыс жауап бермедіңіз",
    fileUploadError: "Файлды жүктеу кезінде қате орын алды"
  },

  application: {
    selectStudent: "Баланы таңдаңыз",
    selectStudentPlaceholder: "Тізімнен баланы таңдаңыз",
    hasApplication: "бұл үйірмеге өтініш жіберілген",
    hasOverlimit: "өтініштер лимитінен асты",
    address: "Мекенжайы",
    addressPlaceholder: "Мекенжайды енгізіңіз",
    socialCategory: "Санаты",
    socialCategoryPlaceholder: "Санатты таңдаңыз",
    phoneNumber: "Телефон нөмірі",
    phoneNumberPlaceholder: "Телефон нөмірін енгізіңіз",
    email: "Электрондық пошта",
    emailPlaceholder: "Электрондық поштаны енгізіңіз",
    selectSubgroup: "Ішкі топты таңдаңыз",
    selectSubgroupPlaceholder: "Қолжетімді ішкі топты таңдаңыз",
    dataAgreement: {
      confirm: "Мен дербес деректерді өңдеуге келісім беремін"
    },
    memo: {
      confirm: "Мен жадынамамен танысқанымды растаймын"
    },
    documents: {
      birthCertificate: "Туу туралы куәлік",
      medicalCertificate: "Медициналық анықтама",
      uploadPlaceholder: "Файлды жүктеу",
      socialCertificate: "Әлеуметтік санатты растайтын анықтама",
      delete: "Жою"
    },
    submitApplication: "Өтініш жіберу",
    cancel: "Бас тарту",
    available_count: "Қолжетімді орын саны",
    place: "Орын",
    studyInCollege: "Колледжде оқиды",
    exitConfirmation: {
      title: "Өтінішті жабуға сенімдісіз ба?",
      message: "Енгізілген барлық деректер жоғалады",
      continue: "Өтінішті жалғастыру",
      exit: "Шығу"
    },
    loadingData: "Деректеріңізді жүктеудеміз...",
    "grade": "Сыныбы",
    "gradePlaceholder": "Мысалы: 5",
    "letter": "Сынып әріпі", 
    "letterPlaceholder": "Мысалы: А",
    "studentNotInSchool": "Мектепке бармайды",
    "schoolStatus": "Оқу статусы",
    "studiesAtSchool": "Мектепте оқиды",
    "notStudiesAtSchool": "Мектепке бармайды",
    "profileCompletionRequired": "Өтініш жіберу үшін профильдегі барлық мәліметті толтыру қажет. Профиль бетіне бағыттаймыз...",
    profileIncomplete: "Профиль толтырылмаған",
    profileCompleteRequired: "Өтініш жіберу үшін профильдегі барлық мәліметті толтыру қажет. Профиль бетіне бағыттаймыз...",
    redirectIn: "Бағыттау",
    goToProfileNow: "Профильге",
    redirectingToProfile: "Профиль бетіне бағыттаудамыз",
    view: "Көрсету",
    hide: "Жабу",
    schoolNamePlaceholder: "Мысалы: Ақтау №20 мектеп",
    schoolName: "Мектебі",
    CollegeNamePlaceholder: "Мысалы: Маңғыстау өнер колледжі",
    CollegeName: "Колледжі"
  },

  validation: {
    required: "Бұл өріс міндетті",
    email: "Дұрыс электрондық пошта мекенжайын енгізіңіз",
    phone: "Дұрыс телефон нөмірін енгізіңіз",
    fillRequiredFields: "Барлық міндетті өрістерді толтырыңыз",
    confirmMemoRequired: "Жадынамамен танысқаныңызды растаңыз",
    agreeRequired: "Деректерді өңдеуге келісім қажет",
    socialDocumentRequired: "Әлеуметтік санатты растайтын құжатты жүктеңіз",
    gradeAndLetterRequired: "Балаңыздың сыныбын белгілеңіз",
    onlyNumber: "Тек сандар болуы қажет",
    maximum9: "Құжат номері тек сандардан тұруы тиіс (9 сан)",
    futureDate: "Берілген уақыты дұрыс емес",
    notNecessary: "(міндетті емес)",
    fileTooLarge: "Файл тым үлкен"
  },

  favorites: {
    title: "Таңдаулы үйірмелер",
    subtitle: "Сіздің таңдаулы үйірмелер ({count})",
    loading: "Таңдаулы үйірмелер жүктелуде...",
    emptyTitle: "Таңдаулылар әлі бос",
    emptyText: "Кейін оңай табу үшін ұнаған үйірмелерді сақтаңыз",
    exploreCourses: "Үйірмелерді іздеу",
    removed: "Үйірме таңдаулылардан жойылды"
  },

  dataAgreement: {
    title: "Дербес деректерге қол жеткізуге келісімі"
  },

  memo: {
    title: "Ата-анаға жадынама"
  },

  auth: {
    sessionExpired: "Сессияңыз аяқталды. Қайта кіріңіз."
  }
};
